// extracted by mini-css-extract-plugin
export default {"subInfo":"UpgradeSubscription_subInfo__qku5x"};